import type { GuideTourStep } from "../../GuideTour/types";

/** Selectors match ids on `AddFundsHelpShell`. */
export const WL_ADD_FUNDS_HELP_STEPS: GuideTourStep[] = [
  {
    id: "af-intro",
    selector: "#wl-af-intro",
    content:
      "From My brands list you can open any brand, then add points with Add funds. This tour walks through that flow.",
  },
  {
    id: "af-brands",
    selector: "#wl-af-brand-list",
    content: "Tap a brand card to open its details — pick any brand from your list.",
  },
  {
    id: "af-details-balance",
    selector: "#wl-af-details-balance",
    content: "The details screen shows your points balance and site URL for this brand.",
  },
  {
    id: "af-add-funds",
    selector: "#wl-af-add-funds",
    content: "Now click on Add funds",
  },
  {
    id: "af-packages",
    selector: "#wl-af-packages-section",
    content: "Select a package, then tap Continue.",
  },
  {
    id: "af-payment",
    selector: "#wl-af-payment-methods",
    content: "Add funds offers Crypto or Fiat. Choose one, then Continue to complete payment",
  },
];
